<ng-container *ngIf="showNameDOBField" [ngSwitch]="layoutType">
  <div *ngSwitchCase="'form-left-right-column'" [ngClass]="formGroupClasses" class="member-details">
    <label for="nameAndDOB" class="{{ labelColumnClass }} col-form-label">Name/DOB</label>
    <div class="{{ inputColumnClass }}">
      <input
        type="text"
        [value]="nameAndDOB || ''"
        name="nameAndDOB"
        id="nameAndDOB"
        class="form-control"
        [class.loading]="loading"
        disabled
      />
    </div>
  </div>
  <div *ngSwitchCase="'form-full-width-column'" [ngClass]="formGroupClasses" class="member-details">
    <label class="{{ labelColumnClass }}" for="nameAndDOB">Name/DOB</label>
    <div class="{{ inputColumnClass }}">
      <input
        type="text"
        [value]="nameAndDOB || ''"
        name="nameAndDOB"
        id="nameAndDOB"
        class="form-control"
        [class.loading]="loading"
        disabled
      />
    </div>
  </div>
  <div *ngSwitchCase="'form-full-width-inline-column'" [ngClass]="formGroupClasses" class="member-details">
    <label for="nameAndDOB">Name/DOB</label>
    <input
      type="text"
      [value]="nameAndDOB || ''"
      name="nameAndDOB"
      id="nameAndDOB"
      class="form-control"
      [class.loading]="loading"
      disabled
    />
  </div>
  <ng-container *ngSwitchDefault>Name/DOB: {{ nameAndDOB }}</ng-container>
</ng-container>
